<script>
    import { uiState } from "@app/store/uiStore.svelte.js";
    import { externalDataState } from "@app/store/externalDataStore.svelte.js";
    import { modalState, showModal, hideModal } from "@app/store/modalStore.svelte.js";
    import { toast } from "@zerodevx/svelte-toast";
    import { fade } from "svelte/transition";
    import { projectState, updateProjectMedia } from "@app/store/projectStore.svelte.js";
    import { playerState, updateTime, updateDuration, updatePlayingStatus, updatePlayerSpeed} from "@app/store/playerStore.svelte.js";
    import { onMount } from "svelte";
    import * as m from "@app/paraglide/messages.js";

    /* Firebase */
    import firebase from "@app/configs/firebase.js";

    import _Event from "@cclib/classes/event.js";
    import _EventGroup from "@cclib/classes/eventGroup.js";
    import _Project from "@cclib/classes/project.js";
    import loadMedia from "@cclib/functions/projects/loadMedia.js";

    let progress = $state(0),
        statusMsg = $state(m.iconik_proxy_status_connecting()),
        mediaUrl;

    async function updateStatus(statusInfo) {
        progress = statusInfo.progress;
        statusMsg = statusInfo.msg;
    }

    async function getFileSize() {
        try {
            const response = await fetch(projectState.media.path, {
                method: "HEAD",
            });
            const fileSize = response.headers.get("content-length");
            return fileSize;
        } catch (err) {
            return false;
        }
    }

    onMount(async () => {
        try {
            console.log("Getting proxy information for "+ externalDataState.assetId);
            player.src = '';
            await updateStatus({
                progress: 10,
                msg: m.iconik_proxy_status_getting_proxy(),
            });

            uiState.timeline = false;
            updateDuration(false);

            let proxyInfo = await firebase.functions().httpsCallable("v8IconikGetProxy")(externalDataState.assetId);

            // console.log(proxyInfo);

            await updateStatus({
                progress: 45,
                msg: m.iconik_proxy_status_reloading_proxy(),
            });

            mediaUrl = proxyInfo.data.objects[0].url;

            externalDataState.mediaUrl = mediaUrl;

            await updateStatus({
                progress: 50,
                msg: m.iconik_proxy_status_importing_media(),
            });

            updateProjectMedia({
                projectName: projectState.name,
                storage: projectState.media.storage,
                mediaUrl: mediaUrl,
                incode: 0,
                frameRate: projectState.frameRate,
                dropFrame: projectState.dropFrame,
                aspectRatio: "16/9"
            });

            let mediaType = projectState.media.type === "video/quicktime" ? "video/mp4" : projectState.media.type;                

            let fileSize = await getFileSize(projectState.media.path);
            if (fileSize) {
                const sizeInBytes = parseInt(fileSize);
                const sizeInKilobytes = sizeInBytes / 1024;
                const sizeInMegabytes = sizeInKilobytes / 1024;
                if (sizeInMegabytes < 512) {
                    projectState.media.useFallback = false;
                }
            }

            /* Update media player global */
            player.src = { src: projectState.media.path, type: mediaType};

            await updateStatus({
                progress: 100,
                msg: m.iconik_proxy_status_complete(),
            });

            toast.push(m.iconik_proxy_success_toast(), {
                classes: ["toast-success"],
            });

            setTimeout(() => {
                uiState.timeline = true;
                hideModal();
            }, 1000);
        } catch (err) {
            console.log(err);
            console.log(err.message);
            toast.push(m.iconik_proxy_failed_toast({ error: err.message }), {
                classes: ["toast-danger"],
            });
            hideModal();
        }
    });
</script>

<div
    transition:fade={{ duration: 100 }}
    class="modal {modalState.selected === 'iconikGetProxy' ? 'show d-block' : ''}"
    role="dialog"
    aria-labelledby="iconikProxyTitle"
    aria-describedby="iconikProxyDescription"
    tabindex="-1"
    id="IconikGetProxyModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="iconikProxyTitle">{m.iconik_proxy_title()}</h4>
                <button
                    type="button"
                    class="btn-close"
                    id="closeIconikProxyModal"
                    aria-label={m.iconik_proxy_close_label()}
                    onclick={hideModal}
></button>
            </div>
            <div class="modal-body" id="iconikProxyDescription">
                <p role="status" aria-live="polite">
                    <i class="bi bi-exclamation-diamond-fill" aria-hidden="true"></i> {statusMsg}
                </p>
                <div class="progress">
                    <div
                        class="progress-bar bg-primary progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style="width: {progress}%;"
                        aria-valuenow={progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        aria-label={m.iconik_proxy_progress_label()}>
                        {progress}%
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
